"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var SelectMultiple_1 = require("./SelectMultiple");
var NativeSelect_1 = require("./NativeSelect");
var SimulateSelect_1 = require("./SimulateSelect");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.Select = forward_ref_with_statics_1.forwardRefWithStatics(function Select(_a, ref) {
    var type = _a.type, props = tslib_1.__rest(_a, ["type"]);
    // 兼容早期原生下拉选择
    if (type === "native") {
        return react_1.default.createElement(NativeSelect_1.NativeSelect, tslib_1.__assign({ ref: ref }, props));
    }
    return react_1.default.createElement(SimulateSelect_1.SimulateSelect, tslib_1.__assign({ ref: ref }, props));
}, {
    Multiple: SelectMultiple_1.SelectMultiple,
    defaultLabelAlign: "middle",
});
exports.Select.displayName = "Select";
//# sourceMappingURL=Select.js.map